var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddArtistAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.48499H22.5V13.485H20.5V4.48499H4.5V20.485H13.5V22.485H2.5V2.48499ZM12.5 7.48499H16.5V9.48499H14.5V14.485C14.4997 15.1217 14.2967 15.7419 13.9206 16.2557C13.5444 16.7694 13.0145 17.1502 12.4076 17.3428C11.8007 17.5355 11.1482 17.53 10.5446 17.3272C9.94098 17.1244 9.41755 16.7348 9.05006 16.2148C8.68256 15.6948 8.49005 15.0714 8.5004 14.4347C8.51074 13.798 8.7234 13.1811 9.10759 12.6733C9.49179 12.1655 10.0276 11.7932 10.6375 11.6101C11.2473 11.427 11.8997 11.4427 12.5 11.655V7.48499ZM12.5 14.485C12.5 14.2198 12.3946 13.9654 12.2071 13.7779C12.0196 13.5903 11.7652 13.485 11.5 13.485C11.2348 13.485 10.9804 13.5903 10.7929 13.7779C10.6054 13.9654 10.5 14.2198 10.5 14.485C10.5 14.7502 10.6054 15.0046 10.7929 15.1921C10.9804 15.3796 11.2348 15.485 11.5 15.485C11.7652 15.485 12.0196 15.3796 12.2071 15.1921C12.3946 15.0046 12.5 14.7502 12.5 14.485ZM20.5 15.485V18.485H23.5V20.485H20.5V23.485H18.5V20.485H15.5V18.485H18.5V15.485H20.5Z",
    fill: "#5B4E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddArtistAlbum);
export default __webpack_public_path__ + "static/media/addArtistAlbum.462921f95b788cd0441005440a6aa152.svg";
export { ForwardRef as ReactComponent };